/**
 * @generated SignedSource<<aa6363613e6a0fe09bb43b66813898bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StartWhen = "ITEM_ADDED" | "ITEM_DELETED" | "ITEM_UPDATED" | "NO_START" | "%future added value";
export type Status = "ACTIVE" | "ARCHIVED" | "DRAFT" | "INACTIVE" | "TEMPLATE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type processDefinitionsTemplateQueryFragment$data = {
  readonly content: ReadonlyArray<{
    readonly createdAt: any;
    readonly definitionKey: string;
    readonly definitionName: string;
    readonly definitionVersion: string | null | undefined;
    readonly id: string;
    readonly modifiedAt: any;
    readonly startWhen: StartWhen;
    readonly status: Status;
  }>;
  readonly pageInfo: {
    readonly " $fragmentSpreads": FragmentRefs<"listPaginationQueryFragment">;
  };
  readonly " $fragmentType": "processDefinitionsTemplateQueryFragment";
};
export type processDefinitionsTemplateQueryFragment$key = {
  readonly " $data"?: processDefinitionsTemplateQueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"processDefinitionsTemplateQueryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "processDefinitionsTemplateQueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProcessDefinition",
      "kind": "LinkedField",
      "name": "content",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "definitionKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "definitionName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "definitionVersion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "modifiedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startWhen",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "listPaginationQueryFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProcessDefinitionPage",
  "abstractKey": null
};

(node as any).hash = "e3c92b27477c572a18be89fab14476f8";

export default node;
